<script setup lang="ts">
const props = defineProps<{ langPath: string }>()

const phoneNumbers = [
  props.langPath + '.contact.phones.number-1',
  props.langPath + '.contact.phones.number-2',
]

const openingHours = props.langPath + '.open-hours.dates.'
const openingDates = [
  {
    info: openingHours + 'date-1.info',
    title: openingHours + 'date-1.title',
    hours: [
      openingHours + 'date-1.hours.hour-1',
      openingHours + 'date-1.hours.hour-2',
    ],
  },
  {
    info: openingHours + 'date-2.info',
    title: openingHours + 'date-2.title',
    hours: [
      openingHours + 'date-2.hours.hour-1',
      openingHours + 'date-2.hours.hour-2',
    ],
  },
]
</script>

<template>
  <div class="flex flex-col pl-8 sm:pl-32">
    <div class="pb-20 pt-20">
      <div class="font-pragmatica-ext mb-10 text-4xl font-bold">
        {{ $t(props.langPath + '.title') }}
      </div>
      <div class="mb-10">
        <p class="mb-3.5">
          <strong
            v-if="$te(props.langPath + '.address.companyName')"
            class="font-bold"
          >
            {{ $t(props.langPath + '.address.companyName') }}
          </strong>
          <br />
          {{ $t(props.langPath + '.address.street') }}
          <br />
          {{ $t(props.langPath + '.address.city') }}
          <br />
          {{ $t(props.langPath + '.address.country') }}
        </p>
        <p
          v-if="$te(props.langPath + '.address.commercial-register.ico')"
          class="mb-3.5"
        >
          {{ $t(props.langPath + '.address.commercial-register.ico') }}
          <br />
          {{ $t(props.langPath + '.address.commercial-register.dic') }}
        </p>
        <p
          v-if="$te(props.langPath + '.address.commercial-register.title')"
          class="mb-3.5"
        >
          {{ $t(props.langPath + '.address.commercial-register.title') }}
          <br />
          {{ $t(props.langPath + '.address.commercial-register.address') }}
        </p>
      </div>
      <div class="mb-10">
        <h3 class="font-pragmatica-ext mb-3.5 text-xl font-bold">
          {{ $t(props.langPath + '.contact.title') }}
        </h3>
        <p class="mb-3.5">
          <span
            v-for="(number, index) in phoneNumbers"
            :key="index"
            class="block"
          >
            <a
              v-if="$te(number)"
              :href="'tel:' + $t(number)"
              class="text-nowrap no-underline"
            >
              {{ $t(number) }}
            </a>
          </span>
        </p>
        <p class="mb-3.5">
          <a
            :href="'mailto:' + $t(props.langPath + '.contact.email')"
            class="border-b border-black no-underline"
          >
            {{ $t(props.langPath + '.contact.email') }}
          </a>
        </p>
      </div>
      <div v-if="$te(props.langPath + '.open-hours.title')" class="mb-10">
        <div class="font-pragmatica-ext mb-3.5 text-xl font-bold">
          {{ $t(props.langPath + '.open-hours.title') }}
        </div>
        <table class="table-auto border-separate">
          <tbody>
            <tr v-for="(day, index) in openingDates" :key="index">
              <td v-if="$te(day.info)">
                {{ $t(day.info) }}
              </td>
              <template v-else>
                <td v-if="$te(day.title)" class="font-bold">
                  {{ $t(day.title) }}
                </td>
                <td v-for="(hour, id) in day.hours" :key="id">
                  <span v-if="$te(hour)" class="pl-8 font-normal">
                    {{ $t(hour) }}
                  </span>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
